import FrontendLoggerFactory from "@/utils/logging/FrontendLoggerFactory";

const LEGACY_ADMIN_FRONTEND_PATH_ALIASES: Record<string, string | null> = {
  "/admin/users": "/users",
  "/admin/rbac/staff-users": "/settings/team-permissions",
  "/admin/rbac/roles": "/settings/team-permissions",
  "/admin/audit-log": "/settings/audit-log",
  "/admin/jobs": "/settings/jobs",
  "/admin/quickbooks-trials": "/quickbooks-trials",
  "/integrations": "/settings/integrations",
  "/revenue/transactions": "/revenue/billing",
  "/revenue/subscriptions": "/revenue/billing",
  "/revenue/offers-onboarding": "/revenue/billing",
  "/reports/sales-tax": null,
  "/reports/profit-loss": null,
  "/reports/cashflow": null,
};

const logger = FrontendLoggerFactory.getLogger().withComponent(
  "normalizeAdminFrontendPath",
);

export const normalizeAdminFrontendPath = (path: string): string | null => {
  const trimmed = path.trim().replace(/\s+/g, "");
  if (!trimmed.startsWith("/")) {
    logger.debug("Rejected admin frontend path normalization input", {
      operation: "normalize_admin_frontend_path_rejected",
      inputBasePath: trimmed.slice(0, 128),
      reason: "invalid",
    });
    return null;
  }

  const queryIndex = trimmed.search(/[?#]/);
  const basePath = queryIndex === -1 ? trimmed : trimmed.slice(0, queryIndex);
  const suffix = queryIndex === -1 ? "" : trimmed.slice(queryIndex);

  const withoutLegacyPrefix =
    basePath === "/v2"
      ? "/dashboard"
      : basePath.startsWith("/v2/")
        ? basePath.slice("/v2".length)
        : basePath;

  if (withoutLegacyPrefix === "/" || withoutLegacyPrefix === "") {
    return `/dashboard${suffix}`;
  }

  const normalizedPath = Object.prototype.hasOwnProperty.call(
    LEGACY_ADMIN_FRONTEND_PATH_ALIASES,
    withoutLegacyPrefix,
  )
    ? LEGACY_ADMIN_FRONTEND_PATH_ALIASES[withoutLegacyPrefix]
    : withoutLegacyPrefix;

  if (normalizedPath === null) {
    logger.debug("Rejected admin frontend path during normalization", {
      operation: "normalize_admin_frontend_path_rejected",
      inputBasePath: withoutLegacyPrefix,
      hadQueryOrHash: suffix.length > 0,
      reason: "unsupported_alias",
    });
    return null;
  }

  if (
    normalizedPath !== withoutLegacyPrefix ||
    withoutLegacyPrefix !== basePath
  ) {
    logger.debug("Normalized admin frontend path", {
      operation: "normalize_admin_frontend_path_rewritten",
      inputBasePath: basePath,
      normalizedPath,
      hadQueryOrHash: suffix.length > 0,
      reason:
        withoutLegacyPrefix !== basePath ? "legacy_prefix" : "legacy_alias",
    });
  }

  return `${normalizedPath}${suffix}`;
};
